import { render, staticRenderFns } from "./ManualEntitlements.vue?vue&type=template&id=5306c846&scoped=true&"
import script from "./ManualEntitlements.vue?vue&type=script&lang=js&"
export * from "./ManualEntitlements.vue?vue&type=script&lang=js&"
import style0 from "./ManualEntitlements.vue?vue&type=style&index=0&id=5306c846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5306c846",
  null
  
)

export default component.exports